import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from '../security/login/login.component';
import { LayoutComponent } from '../shared-components/layout/layout.component';
import { EmptyHomeComponent } from '../home/empty-home/empty-home.component';

import { McBreadcrumbsModule } from 'ngx-breadcrumbs';
import { PermissionComponent } from '../security/permission/permission.component';
import { RoleComponent } from '../security/role/role.component';
import { RoleListComponent } from '../security/role/role-list.component';
import { LoguedGuardService } from '../security/logued-guard.service';
import { RedirectGuard } from './redirect-guard.service';
import { RoleAddEditComponent } from '../security/role/role-add-edit.component';
import { RoleResolver } from '../security/role/role.resolver';
import { UserComponent } from '../security/user/user.component';
import { UserListComponent } from '../security/user/user-list.component';
import { UserResolver } from '../security/user/user.resolver';
import { UserAddEditComponent } from '../security/user/user-add-edit.component';
import { UserChangePasswordResolver } from '../security/user/user-change-password.resolver';
import { UserChangePasswordComponent } from '../security/user/user-change-password.component';
import { ClienteComponent } from '../cliente/cliente.component';
import { ClienteListComponent } from '../cliente/cliente-list/cliente-list.component';
import { ClienteResolver } from '../cliente/cliente.resolver';
import { ClienteDetailsComponent } from '../cliente/cliente-details/cliente-details.component';
import { ClienteAddEditComponent } from '../cliente/cliente-add-edit/cliente-add-edit.component';

import { ClientesAprobadosListComponent } from '../cliente/clientes-aprobados-list/clientes-aprobados-list.component';
import { CambioSpreadComponent } from '../shared-components/cambio-spread/cambio-spread.component';
import { CambioDolarVentaComponent } from '../shared-components/cambio-dolar-venta/cambio-dolar-venta.component';
import { CambioDolarCompraComponent } from '../shared-components/cambio-dolar-compra/cambio-dolar-compra.component';
import { ConfiguracionComponent } from '../configuracion/configuracion.component';
import { ConfiguracionResolver } from '../configuracion/configuracion.resolver';
import { SaldoResolver } from '../cliente/saldos.resolver';
import { VerSaldosComponent } from '../cliente/ver-saldos/ver-saldos.component';
import { OperacionAddComponent } from '../cliente/operaciones/operacion-add/operacion-add.component';
import { MotivosRechazoComponent } from '../cliente/motivosRechazo/motivosRechazo.component';
import { MotivosRechazoListComponent } from '../cliente/motivosRechazo/motivosRechazo-list.component';
import { MotivosRechazoResolver } from '../cliente/motivosRechazo/motivosRechazo.resolver';
import { MotivosRechazoAddEditComponent } from '../cliente/motivosRechazo/motivosRechazo-add-edit.component';
import { ClienteUserAddEditComponent } from '../cliente/cliente-user-add-edit/cliente-user-add-edit.component';
import { NotificacionComponent } from '../notificacion/notificacion.component';
import { NotificacionListComponent } from '../notificacion/notificacion-list.component';
import { NotificacionResolver } from '../notificacion/notificacion.resolver';
import { NotificacionAddEditComponent } from '../notificacion/notificacion-add-edit.component';
import { ValidarDocumentacionComponent } from '../shared-components/validar-documentacion/validar-documentacion.component';
import { AprobacionClienteResolver } from '../shared-components/validar-documentacion/aprobacionCliente.resolver';
import { ClientesPendientesAprobacionListComponent } from '../cliente/clientes-pendientes-aprobacion-list/clientes-pendientes-aprobacion-list.component';
import { PerfilUserResolver } from '../security/user/perfilUser.resolver';
import { SugerenciaComponent } from '../productos/sugerencia/sugerencia.component';
import { SugerenciaListComponent } from '../productos/sugerencia/sugerencia-list.component';
import { SugerenciaAddEditComponent } from '../productos/sugerencia/sugerencia-add-edit.component';
import { SugerenciaResolver } from '../productos/sugerencia/sugerencia.resolver';
import { CategoriaProductoComponent } from '../productos/categoria-producto/categoria-producto.component';
import { CategoriaProductoListComponent } from '../productos/categoria-producto/categoria-producto-list.component';
import { CategoriaProductoAddEditComponent  } from '../productos/categoria-producto/categoria-producto-add-edit.component';
import { CategoriaProductoResolver } from '../productos/categoria-producto/categoria-producto.resolver';
import { SubcategoriaProductoComponent } from '../productos/subcategoria-producto/subcategoria-producto.component';
import { SubcategoriaProductoListComponent } from '../productos/subcategoria-producto/subcategoria-producto-list.component';
import { SubcategoriaProductoAddEditComponent } from '../productos/subcategoria-producto/subcategoria-producto-add-edit.component';
import { SubcategoriaProductoResolver } from '../productos/subcategoria-producto/subcategoria-producto.resolver';
import { ProveedorComponent } from '../productos/proveedor/proveedor.component';
import { ProveedorListComponent } from '../productos/proveedor/proveedor-list.component';
import { ProveedorAddEditComponent } from '../productos/proveedor/proveedor-add-edit.component';
import { ProveedorResolver } from '../productos/proveedor/proveedor.resolver';
import { ProductoListComponent } from '../productos/producto-list/producto-list.component';
import { ProductoProveedorListComponent } from '../productos/producto-proveedor-list/producto-proveedor-list.component';
import { ProductoResolver } from '../productos/producto.resolver';
import { ProductoAddEditComponent } from '../productos/producto-add-edit/producto-add-edit.component';
import { ProductoComponent } from '../productos/producto.component';
import { ProductoDetailsComponent } from '../productos/producto-details/producto-details.component';
import { ProductoDValidarDatosComponent } from '../productos/producto-validar-datos/producto-validar-datos.component';
import { TalleComponent } from '../productos/talle/talle.component';
import { TalleListComponent } from '../productos/talle/talle-list.component';
import { TalleAddEditComponent } from '../productos/talle/talle-add-edit.component';
import { TalleResolver } from '../productos/talle/talle.resolver';
import { TipoImpresionComponent } from '../productos/tipo-impresion/tipo-impresion.component';
import { TipoImpresionListComponent } from '../productos/tipo-impresion/tipo-impresion-list.component';
import { TipoImpresionAddEditComponent } from '../productos/tipo-impresion/tipo-impresion-add-edit.component';
import { TipoImpresionResolver } from '../productos/tipo-impresion/tipo-impresion.resolver';
import { AcuerdoComponent } from '../acuerdo/acuerdo.component';
import { AcuerdoListComponent } from '../acuerdo/acuerdo-list/acuerdo-list.component';
import { AcuerdoDetailsComponent } from '../acuerdo/acuerdo-details/acuerdo-details.component';
import { AcuerdoResolver } from '../acuerdo/acuerdo.resolver';
import { AcuerdoAddEditComponent } from '../acuerdo/acuerdo-add-edit/acuerdo-add-edit.component';
import { ColorComponent } from '../productos/color/color.component';
import { ColorListComponent } from '../productos/color/color-list.component';
import { ColorAddEditComponent } from '../productos/color/color-add-edit.component';
import { ColorResolver } from '../productos/color/color.resolver';
import { UsuarioClienteResolver } from '../cliente/cliente-user-add-edit/usuario-cliente.resolver';
import { PedidoComponent } from '../pedido/pedido.component';
import { PedidoListComponent } from '../pedido/pedido-list/pedido-list.component';
import { PedidoDetailsComponent } from '../pedido/pedido-details/pedido-details.component';
import { PedidoResolver } from '../pedido/pedido.resolver';
import { ClienteUserMontoMaxComponent } from '../cliente/cliente-user-monto-max/cliente-user-monto-max.component';
import { CotizacionComponent } from '../shared-components/cotizacion/cotizacion.component';
import { CotizacionListComponent } from '../shared-components/cotizacion/cotizacion-list/cotizacion-list.component';
import { CotizacionResolver } from '../shared-components/cotizacion/cotizacion.resolver';
import { CotizacionEditComponent } from '../shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component';
import { AcuerdoUserMontoMaxComponent } from '../acuerdo/acuerdo-user-monto-max/acuerdo-user-monto-max.component';
import { CantidadTotalComponent } from '../productos/cantidad-total/cantidad-total.component';
import { VerAcuerdosComponent } from '../cliente/ver-acuerdos/ver-acuerdos.component';
import { VerPedidosComponent } from '../acuerdo/ver-pedidos/ver-pedidos.component';
import { VerProductosPedidosComponent } from '../acuerdo/ver-productos-pedidos/ver-productos-pedidos.component';
import { SectorComponent } from '../cliente/sectores/sector.component';
import { SectorListComponent } from '../cliente/sectores/sector-list.component';
import { SectorAddEditComponent } from '../cliente/sectores/sector-add-edit.component';
import { SectorResolver } from '../cliente/sectores/sector.resolver';
import { BannerComponent } from '../banner/banner.component';
import { BannerlistComponent } from '../banner/bannerlist/bannerlist.component';
import { BannerResolver } from '../banner/banner.resolver';
import { BannerAddComponent } from '../banner/banner-add/banner-add.component';
import { TiposEnvioComponent } from '../tiposEnvio/tiposEnvio.component';
import { TiposEnvioListComponent } from '../tiposEnvio/tiposEnvio-list.component';
import { TiposEnvioAddEditComponent } from '../tiposEnvio/tiposEnvio-add-edit.component';
import { TiposEnvioResolver } from '../tiposEnvio/tiposEnvio.resolver';
import { ClienteUserMontoMaxMasivoComponent } from '../cliente/cliente-user-monto-max-masivo/cliente-user-monto-max-masivo.component';
import { PrecioModificacionComponent } from '../productos/modificacion-precio/precio-modificacion/precio-modificacion.component';
import { PrecioModificacionListComponent } from '../productos/modificacion-precio/precio-modificacion-list/precio-modificacion-list.component';
import { NotificacionIdComponent } from '../notificacion/notificacion-id/notificacion-id.component';
import { PrecioModificacionAddComponent } from '../productos/modificacion-precio/precio-modificacion-add/precio-modificacion-add.component';
import { CodigosPromocionComponent } from '../pedido/codigos-promocion/codigos-promocion.component';
import { CodigosPromocionListComponent } from '../pedido/codigos-promocion/codigos-promocion-list/codigos-promocion-list.component';
import { CodigosPromocionAddComponent } from '../pedido/codigos-promocion/codigos-promocion-add/codigos-promocion-add.component';
import { ProductoCodigoDescuentoComponent } from '../productos/producto-codigo-descuento/producto-codigo-descuento.component';
import { ProductoAddMassiveComponent } from '../productos/producto-add-massive/producto-add-massive.component';
import { CategoriaProductoAddComponent } from '../productos/categoria-producto-add/categoria-producto-add.component';
import { VerificadorProductosComponent } from '../productos/verificador-productos/verificador-productos/verificador-productos.component';
import { PedidoProveedorListComponent } from '../pedido/pedido-proveedor-list/pedido-proveedor-list.component';
import { BannerCarouselComponent } from '../banner/banner-carousel/banner-carousel.component';
import { CostoEnvioComponent } from '../pedido/costo-envio/costo-envio/costo-envio.component';
import { CostoEnvioListComponent } from '../pedido/costo-envio/costo-envio-list/costo-envio-list.component';
import { CostoEnvioAddComponent } from '../pedido/costo-envio/costo-envio-add/costo-envio-add.component';
import { CostoEnvioResolver } from '../pedido/costo-envio/costo-envio.resolver';
import { CostoEnvioMassiveComponent } from '../pedido/costo-envio/costo-envio-massive/costo-envio-massive.component';
import { CategoriaProductoAddMassiveComponent } from '../productos/carga-masiva/categoria-producto-add-massive/categoria-producto-add-massive.component';
import { DestacadoProductoAddMassiveComponent } from '../productos/carga-masiva/destacado-producto-add-massive/destacado-producto-add-massive.component';
import { ProductosBuscadosComponent } from '../productos/productos-buscados/productos-buscados.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'password/reset', component: LoginComponent, data: { title: 'Cambio de Contraseña' } },
  { path: 'reset-password', component: LoginComponent },
  { path: 'confirm-password/:id', component: LoginComponent },
  {
    path: '', component: LayoutComponent,
    canActivate: [LoguedGuardService], canActivateChild: [LoguedGuardService],
    children: [{
        path: 'home', component: EmptyHomeComponent,
        data: { title: 'Home', profile: true },
      },
      {
        path: 'permisos', component: PermissionComponent,
        data: { title: 'Permisos', profile: true, breadcrumbs: 'Permisos', expectedPermission: 'VISUALIZAR_PERMISOS' }
      },
      {
        path: 'perfil', component: UserAddEditComponent,
        data: { title: 'Perfil', expectedPermission: 'MI_PERFIL' }, resolve: { user: PerfilUserResolver }
      },
      {
        path: 'verificador-productos', component: VerificadorProductosComponent,

        //data: { title: 'Permisos', profile: true, expectedPermission: 'MI_PERFIL'}

        data: { title: 'Verificador Productos', expectedPermission: 'MI_PERFIL' }

      },
      {
        path: 'roles', component: RoleComponent,
        data: { title: 'Roles' },
        children: [{
          path: '', component: RoleListComponent,
          data: { expectedPermission: 'VISUALIZAR_ROLES' },
        },
        {
          path: 'agregar', component: RoleAddEditComponent,
          data: { expectedPermission: 'CREAR_ROL' }, resolve: { role: RoleResolver }
        },
        {
          path: 'editar/:id', component: RoleAddEditComponent,
          data: { expectedPermission: 'EDITAR_ROL' }, resolve: { role: RoleResolver }
        }]
      },
      {
        path: 'usuarios', component: UserComponent,
        data: { title: 'Usuarios', },
        children: [{
          path: '', component: UserListComponent,
          data: { expectedPermission: 'VISUALIZAR_USUARIOS' },
        },
        {
          path: 'agregar', component: UserAddEditComponent,
          data: { expectedPermission: 'CREAR_USUARIO' }, resolve: { user: UserResolver }
        },
        {
          path: 'editar/:id', component: UserAddEditComponent,
          data: { expectedPermission: 'EDITAR_USUARIO' }, resolve: { user: UserResolver }
        },
        {
          path: 'cambiar_password/:id', component: UserChangePasswordComponent,
          data: { expectedPermission: 'CAMBIAR_CONTRASENIA_USUARIO' }, resolve: { user: UserChangePasswordResolver }
        },
        {
          path: 'cambiar_mi_password', component: UserChangePasswordComponent,
          data: { expectedPermission: 'MI_PERFIL' }, resolve: { user: UserChangePasswordResolver }
        }]
      },
      {
        path: 'operaciones/agregar/:id', component: OperacionAddComponent,
        data: { title: 'Agregar Operación', expectedPermission: 'VER_OPERACIONES_CLIENTES' },
          resolve: { cliente: ClienteResolver, saldos: SaldoResolver }
      },
      {
        path: 'clientes', component: ClienteComponent,
        data: { title: 'Clientes' },
        children: [{
          path: '', component: ClienteListComponent,
          data: { title: 'Clientes', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'aprobados', component: ClienteListComponent,
          data: { title: 'Clientes Aprobados', expectedPermission: 'VISUALIZAR_CLIENTES', aprobados: 'true' }
        },
        {
          path: 'ver-saldos/:id', component: VerSaldosComponent,
          data: { title: 'Ver saldos', expectedPermission: 'VER_SALDOS_CLIENTES' },
          resolve: { cliente: ClienteResolver, saldos: SaldoResolver }
        },
        {
          path: 'ver-acuerdos/:id', component: VerAcuerdosComponent,
          data: { title: 'Ver acuerdos', expectedPermission: 'VISUALIZAR_ACUERDO' },
          resolve: { cliente: ClienteResolver }
        },
        {
          path: 'detalles/:id', component: ClienteDetailsComponent,
          data: { title: 'Detalle del cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: ClienteResolver }
        },
        {
          path: 'agregar', component: ClienteAddEditComponent,
          data: { title: 'Agregar cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: ClienteResolver }
        },
        {
          path: 'agregar-usuario/:id', component: ClienteUserAddEditComponent,
          // tslint:disable-next-line:max-line-length
          data: { title: 'Agregar usuario del cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: UsuarioClienteResolver }
        },
        {
          path: 'editar/:id', component: ClienteAddEditComponent,
          data: { title: 'Editar cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: ClienteResolver }
        },
        {
          path: 'editar-usuario/:id', component: ClienteUserAddEditComponent,
          // tslint:disable-next-line:max-line-length
          data: { title: 'Editar usuario del cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: UsuarioClienteResolver }
        },
        {
          path: ':id/monto-max-usuarios', component: ClienteUserMontoMaxComponent,
          // tslint:disable-next-line:max-line-length
          data: { title: 'Cambiar tipo y monto max del cliente', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: ClienteResolver }
        },
        {
          path: ':id/monto-max-usuarios-masivo', component: ClienteUserMontoMaxMasivoComponent,
          // tslint:disable-next-line:max-line-length
          data: { title: 'Cambiar tipo y monto max del cliente masivo', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { cliente: ClienteResolver }
        },
        {
          path: 'validar-documentacion/:id', component: ValidarDocumentacionComponent,
          data: { title: 'Validar documentación', expectedPermission: 'VISUALIZAR_CLIENTES' },
           resolve: { validarDocumentacion: AprobacionClienteResolver }
        },
        {
          path: 'pendientes_aprobacion', component: ClientesPendientesAprobacionListComponent,
          data: { title: 'Clientes Pendientes de Aprobación', expectedPermission: 'VISUALIZAR_CLIENTES' }
        }]
      },
      {
        path: 'acuerdos', component: AcuerdoComponent,
        data: { title: 'Acuerdos de Venta' },
        children: [
        {
          path: '', component: AcuerdoListComponent,
          data: { title: 'Acuerdos de Venta', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'detalles/:id', component: AcuerdoDetailsComponent,
          data: { title: 'Detalle del acuerdo', expectedPermission: 'VISUALIZAR_ACUERDO' }, resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: ':id/monto-max-usuarios', component: AcuerdoUserMontoMaxComponent,
          // tslint:disable-next-line:max-line-length
          data: { title: 'Tipo y monto max del cliente en el acuerdo', expectedPermission: 'VISUALIZAR_ACUERDO' }, resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: 'ver-pedidos/:id', component: VerPedidosComponent,
          data: { title: 'Ver pedidos', expectedPermission: 'VISUALIZAR_ACUERDO' },
          resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: 'agregar', component: AcuerdoAddEditComponent,
          data: { title: 'Agregar acuerdo', expectedPermission: 'CREAR_ACUERDO' }, resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: 'editar/:id', component: AcuerdoAddEditComponent,
          data: { title: 'Editar acuerdo', expectedPermission: 'EDITAR_ACUERDO' }, resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: 'replicar/:id', component: AcuerdoAddEditComponent,
          data: { title: 'Replicar acuerdo', expectedPermission: 'EDITAR_ACUERDO' }, resolve: { acuerdo: AcuerdoResolver }
        },
        {
          path: 'ver-productos-acuerdo/:id', component: VerProductosPedidosComponent,
          data: { title: 'Ver productos pedidos', expectedPermission: 'VISUALIZAR_ACUERDO' },
          resolve: { acuerdo: AcuerdoResolver }
        }]
      },
      {
        path: 'pedidos', component: PedidoComponent,
        data: { title: 'Pedidos recibidos' },
        children: [
        {
          path: '', component: PedidoListComponent,
          data: { title: 'Pedidos recibidos', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'detalles/:id', component: PedidoDetailsComponent,
          data: { title: 'Detalle del pedido', expectedPermission: 'VISUALIZAR_ACUERDO' }, resolve: { acuerdo: PedidoResolver }
        },
        {
          path: 'por-proveedor', component: PedidoProveedorListComponent,
          data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }//, resolve: { producto: PedidoResolver }
        }
        ]
      },
      {
        path: 'tipos-impresion', component: TipoImpresionComponent,
        data: { title: 'Tipos de Impresión', },
        children: [{
          path: '', component: TipoImpresionListComponent,
          data: { expectedPermission: 'VISUALIZAR_TIPOS_IMPRESION' },
        },
        {
          path: 'agregar', component: TipoImpresionAddEditComponent,
          data: { expectedPermission: 'CREAR_TIPO_IMPRESION' }, resolve: { user: TipoImpresionResolver }
        },
        {
          path: 'editar/:id', component: TipoImpresionAddEditComponent,
          data: { expectedPermission: 'EDITAR_TIPO_IMPRESION' }, resolve: { user: TipoImpresionResolver }
        }]
      },
      {
        path: 'notificaciones', component: NotificacionComponent,
        data: { title: 'Notificaciones' },
        children: [{
          path: '', component: NotificacionListComponent,
          data: { title: 'Notificaciones', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'agregar', component: NotificacionAddEditComponent,
          data: { title: 'Agregar notificacion', expectedPermission: 'VISUALIZAR_CLIENTES' },
          resolve: { notificacion: NotificacionResolver }
        },
        {
          path: 'editar/:id', component: NotificacionAddEditComponent,
          data: { title: 'Editar notificacion', expectedPermission: 'VISUALIZAR_CLIENTES' }, resolve: { notificacion: NotificacionResolver }
        },
        {
          path: ':id', component: NotificacionIdComponent,
          data: { title: 'Notificacion', expectedPermission: 'VISUALIZAR_CLIENTES' }
        }
      ]
      },
      {
        path: 'modificaciones-precio', component: PrecioModificacionComponent,
        data: { title: 'Modificaciones Precio' },
        children: [{
          path: '', component: PrecioModificacionListComponent,
          data: { title: 'Modificaciones Precio', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'agregar', component: PrecioModificacionAddComponent,
          data: { title: 'Agregar modificacion precio', expectedPermission: 'VISUALIZAR_CLIENTES' }
        }
      ]
      },
      {
        path: 'codigos-promocion', component: CodigosPromocionComponent,
        data: { title: 'Códigos de promoción' },
        children: [{
          path: '', component: CodigosPromocionListComponent,
          data: { title: 'Códigos de promoción', expectedPermission: 'VISUALIZAR_CLIENTES' }
        },
        {
          path: 'agregar', component: CodigosPromocionAddComponent,
          data: { title: 'Agregar Código de promoción', expectedPermission: 'VISUALIZAR_CLIENTES' }
        }
      ]
      },
      {
        path: 'configuraciones', component: ConfiguracionComponent,
        data: {title: 'Configuraciones', expectedPermission: 'MODIFICAR_SPREAD'},
      },
      {
        path: 'sugerencias', component: SugerenciaComponent,
        data: { title: 'Sugerencias', },
        children: [{
          path: '', component: SugerenciaListComponent,
          data: { expectedPermission: 'VISUALIZAR_SUGERENCIAS' },
        },
        {
          path: 'agregar', component: SugerenciaAddEditComponent,
          data: { expectedPermission: 'CREAR_SUGERENCIA' }, resolve: { user: SugerenciaResolver }
        },
        {
          path: 'editar/:id', component: SugerenciaAddEditComponent,
          data: { expectedPermission: 'EDITAR_SUGERENCIA' }, resolve: { user: SugerenciaResolver }
        }]
      },
      {
        path: 'talles', component: TalleComponent,
        data: { title: 'Talles', },
        children: [{
          path: '', component: TalleListComponent,
          data: { expectedPermission: 'VISUALIZAR_TALLES' },
        },
        {
          path: 'agregar', component: TalleAddEditComponent,
          data: { expectedPermission: 'CREAR_TALLE' }, resolve: { user: TalleResolver }
        },
        {
          path: 'editar/:id', component: TalleAddEditComponent,
          data: { expectedPermission: 'EDITAR_TALLE' }, resolve: { user: TalleResolver }
        }]
      },
      {
        path: 'colores', component: ColorComponent,
        data: { title: 'Colores', },
        children: [{
          path: '', component: ColorListComponent,
          data: { expectedPermission: 'VISUALIZAR_COLORES' },
        },
        {
          path: 'agregar', component: ColorAddEditComponent,
          data: { expectedPermission: 'CREAR_COLOR' }, resolve: { user: ColorResolver }
        },
        {
          path: 'editar/:id', component: ColorAddEditComponent,
          data: { expectedPermission: 'EDITAR_COLOR' }, resolve: { user: ColorResolver }
        }]
      },
      {
        path: 'categorias', component: CategoriaProductoComponent,
        data: { title: 'Categorías de Productos', },
        children: [{
          path: '', component: CategoriaProductoListComponent,
          data: { expectedPermission: 'VISUALIZAR_CATEGORIAS_PRODUCTO' },
        },
        {
          path: 'agregar', component: CategoriaProductoAddComponent,
          data: { expectedPermission: 'CREAR_CATEGORIA_PRODUCTO' }, resolve: { user: CategoriaProductoResolver }
        },
        {
          path: 'editar/:id', component: CategoriaProductoAddEditComponent,
          data: { expectedPermission: 'EDITAR_CATEGORIA_PRODUCTO' }, resolve: { user: CategoriaProductoResolver }
        }]
      },
      {
        path: 'subcategorias', component: SubcategoriaProductoComponent,
        data: { title: 'Subcategorías de Productos', },
        children: [{
          path: '', component: SubcategoriaProductoListComponent,
          data: { expectedPermission: 'VISUALIZAR_SUBCATEGORIAS_PRODUCTO' },
        },
        {
          path: 'agregar', component: SubcategoriaProductoAddEditComponent,
          data: { expectedPermission: 'CREAR_SUBCATEGORIA_PRODUCTO' }, resolve: { user: SubcategoriaProductoResolver }
        },
        {
          path: 'editar/:id', component: SubcategoriaProductoAddEditComponent,
          data: { expectedPermission: 'EDITAR_SUBCATEGORIA_PRODUCTO' }, resolve: { user: SubcategoriaProductoResolver }
        }]
      },
      {
        path: 'proveedores', component: ProveedorComponent,
        data: { title: 'Proveedores de Productos', },
        children: [{
          path: '', component: ProveedorListComponent,
          data: { expectedPermission: 'VISUALIZAR_PROVEEDORES' },
        },
        {
          path: 'agregar', component: ProveedorAddEditComponent,
          data: { expectedPermission: 'CREAR_PROVEEDOR' }, resolve: { user: ProveedorResolver }
        },
        {
          path: 'editar/:id', component: ProveedorAddEditComponent,
          data: { expectedPermission: 'EDITAR_PROVEEDOR' }, resolve: { user: ProveedorResolver }
        }]
      },
      {
        path: 'costos-envio', component: CostoEnvioComponent,
        data: { title: 'Costos de Envio', },
        children: [{
          path: '', component: CostoEnvioListComponent,
          data: { expectedPermission: 'VISUALIZAR_PROVEEDORES' },
        },
        {
          path: 'agregar', component: CostoEnvioAddComponent,
          data: { expectedPermission: 'CREAR_PROVEEDOR' }, resolve: { user: CostoEnvioResolver }
        },
        {
          path: 'editar/:id', component: CostoEnvioAddComponent,
          data: { expectedPermission: 'EDITAR_PROVEEDOR' }, resolve: { user: CostoEnvioResolver }
        },
        {
          path: 'massive', component: CostoEnvioMassiveComponent,
          data: { expectedPermission: 'VISUALIZAR_PROVEEDORES' },
        }]
      },
      {
        path: 'productos', component: ProductoComponent,
        data: { title: 'Productos' },
        children: [
          {
            path: '', component: ProductoListComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' },
          },
          {
            path: 'detalles/:id', component: ProductoDetailsComponent,
            data: { title: 'Detalle del Producto', expectedPermission: 'VISUALIZAR_PRODUCTO' }, resolve: { producto: ProductoResolver }
          },
          {
            path: 'agregar', component: ProductoAddEditComponent,
            data: { expectedPermission: 'CREAR_PRODUCTO' }, resolve: { user: ProductoResolver }
          },
          {
            path: 'agregar-masivo', component: ProductoAddMassiveComponent,
            data: { expectedPermission: 'CREAR_PRODUCTO' }, resolve: { user: ProductoResolver }
          },
          {
            path: 'editar/:id', component: ProductoAddEditComponent,
            data: { expectedPermission: 'EDITAR_PRODUCTO' }, resolve: { user: ProductoResolver }
          },
          {
            path: 'agregar-codigo/:id', component: ProductoCodigoDescuentoComponent,
            data: { expectedPermission: 'EDITAR_PRODUCTO' }
          },
          {
            path: 'validar', component: ProductoDValidarDatosComponent,
            data: { expectedPermission: 'EDITAR_PRODUCTO' }, resolve: { user: ProductoResolver }
          },
          {
            path: 'pedidos/:id', component: CantidadTotalComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }, resolve: { user: ProductoResolver }
          },
          {
            path: 'por-proveedor', component: ProductoProveedorListComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }//, resolve: { producto: ProductoResolver }
          },
          {
            path: 'categoria-masivo', component: CategoriaProductoAddMassiveComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }//, resolve: { producto: ProductoResolver }
          },
          {
            path: 'destacado-masivo', component: DestacadoProductoAddMassiveComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }//, resolve: { producto: ProductoResolver }
          },
          {
            path: 'productos-buscados', component: ProductosBuscadosComponent,
            data: { expectedPermission: 'VISUALIZAR_PRODUCTOS' }//, resolve: { producto: ProductoResolver }
          }
        ]
      },
      {
        path: 'sectores', component: SectorComponent,
        data: { title: 'Sectores comerciales', },
        children: [
          {
            path: '', component: SectorListComponent,
            data: { expectedPermission: 'VISUALIZAR_SECTORES' },
          },
          {
            path: 'agregar', component: SectorAddEditComponent,
            data: { expectedPermission: 'CREAR_SECTORES' }, resolve: { user: SectorResolver }
          },
          {
            path: 'editar/:id', component: SectorAddEditComponent,
            data: { expectedPermission: 'EDITAR_SECTORES' }, resolve: { user: SectorResolver }
          },
        ]
      },
      {
        path: 'motivosRechazo', component: MotivosRechazoComponent,
        data: { title: 'Motivos de rechazo', },
        children: [
          {
            path: '', component: MotivosRechazoListComponent,
            data: { expectedPermission: 'VISUALIZAR_MOTIVOS_RECHAZO' },
          },
          {
            path: 'agregar', component: MotivosRechazoAddEditComponent,
            data: { expectedPermission: 'CREAR_MOTIVOS_RECHAZO' }, resolve: { user: MotivosRechazoResolver }
          },
          {
            path: 'editar/:id', component: MotivosRechazoAddEditComponent,
            data: { expectedPermission: 'EDITAR_MOTIVOS_RECHAZO' }, resolve: { user: MotivosRechazoResolver }
          },
        ]
      },
      {
        path: 'tiposEnvio', component: TiposEnvioComponent,
        data: { title: 'Tipos de envío', },
        children: [
          {
            path: '', component:  TiposEnvioListComponent,
            data: { expectedPermission: 'VISUALIZAR_TIPOS_ENVIO' },
          },
          {
            path: 'agregar', component:  TiposEnvioAddEditComponent,
            data: { expectedPermission: 'CREAR_TIPOS_ENVIO' }, resolve: { user:  TiposEnvioResolver }
          },
          {
            path: 'editar/:id', component:  TiposEnvioAddEditComponent,
            data: { expectedPermission: 'EDITAR_TIPOS_ENVIO' }, resolve: { user:  TiposEnvioResolver }
          },
        ]
      },
      {
        path: 'cotizacion', component: CotizacionComponent,
        data: { title: 'Cotizacion' },
        children: [{
          path: '', component: CotizacionListComponent,
          data: { expectedPermission: 'MODIFICAR_COTIZACION_DOLAR_PESO' },
        },
        {
          path: ':id', component: CotizacionEditComponent,
          data: { expectedPermission: 'MODIFICAR_COTIZACION_DOLAR_PESO' }, resolve: { cotizacion: CotizacionResolver }
        }
      ]
      },
      {
        path: 'banner', component: BannerComponent,
        data: { title: 'Banner' },
        children: [{
          path: '', component: BannerCarouselComponent,
          data: { expectedPermission: 'VISUALIZAR_BANNERS' },
        },
        {
          path: 'new', component: BannerAddComponent,
          data: { expectedPermission: 'CREAR_BANNERS' }, resolve: { banner: BannerResolver }
        }/*,
        {
          path: ':id', component: BannerAddComponent,
          data: { expectedPermission: 'VISUALIZAR_BANNERS' }, resolve: { banner: BannerResolver }
        }*/
      ]
      },
      { path: '**', redirectTo: '', canActivate: [RedirectGuard] },
    ]
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), McBreadcrumbsModule.forRoot()],
  exports: [RouterModule, McBreadcrumbsModule],
  providers: [
    RedirectGuard
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/router/app-routing.module.ts